var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tasks" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: { select: true, "show-subjects": false },
          on: { "type-workflow-list": _vm.workflowList },
        },
        [
          _vm.localType === "kanban"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeDropdown,
                      expression: "closeDropdown",
                    },
                  ],
                  staticClass: "custom-select",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            content: _vm.selectedWorkflowTitle,
                            placement: "right",
                            followCursor: true,
                          },
                          expression:
                            "{\n                    content: selectedWorkflowTitle,\n                    placement: 'right',\n                    followCursor: true,\n                }",
                        },
                      ],
                      staticClass: "selected-option",
                      on: { click: _vm.toggleDropdown },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.selectedWorkflowTitle) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dropdownOpen
                    ? _c(
                        "div",
                        { staticClass: "options-workflow" },
                        _vm._l(_vm.getWorkflows(), function (option) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: option.label,
                                    placement: "right",
                                    followCursor: true,
                                  },
                                  expression:
                                    "{\n                        content: option.label,\n                        placement: 'right',\n                        followCursor: true,\n                    }",
                                },
                              ],
                              key: option.value,
                              staticClass: "option-workflow",
                              on: {
                                click: function ($event) {
                                  return _vm.selectOption(option)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    option.label.length > 15
                                      ? option.label.substring(0, 15) + "..."
                                      : option.label
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.updatedCount > 0
          ? _c("div", { staticClass: "task-update-notification" }, [
              _c(
                "div",
                {
                  staticClass: "notification-close",
                  on: { click: _vm.ignoreUpdates },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("close"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "notification-content" }, [
                _c("div", { staticClass: "notification-icon" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("sync"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notification-message" }, [
                  _c("div", { staticClass: "notification-title" }, [
                    _vm._v("Değişiklikler Mevcut"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notification-description" }, [
                    _vm._v("\n                        Çalışma alanında "),
                    _c("span", { staticClass: "update-count" }, [
                      _vm._v(_vm._s(_vm.updatedCount)),
                    ]),
                    _vm._v(
                      " yeni değişiklik\n                        algılandı.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.refreshTasks },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("refresh"),
                          ]),
                          _vm._v(" Yenile\n                        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-button", { on: { click: _vm.ignoreUpdates } }, [
                        _vm._v(" Yoksay"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("SidebarChild", {
            attrs: {
              items: _vm.filteredMenuItems,
              "selected-item": _vm.localType,
              focusActive: true,
            },
            on: { selected: _vm.handleTypeChange, clicked: _vm.fnClicked },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "page-content-wrapper" }, [
            ["kanban", "list", "archive", "done"].includes(_vm.localType)
              ? _c(
                  "div",
                  { staticClass: "head-bar" },
                  [
                    _vm.localType === "kanban"
                      ? _c("task-filter-bar", {
                          ref: "taskFilterBar",
                          attrs: {
                            "show-overdue": Boolean(_vm.showOverdue),
                            assignees: _vm.assignees,
                            owners: _vm.owners,
                            followers: _vm.followers,
                            createdBy: _vm.createdBy,
                            "workflow-id": _vm.workflowId || null,
                            "checked-items": _vm.checkedItems,
                            "checked-all-tasks": _vm.checkedAllTask,
                            "checked-any-tasks": _vm.checkedAnyTasks(),
                            "batch-operation-items": _vm.batchOperationItems(),
                            "show-operations": true,
                            "show-batch-operations":
                              !!_vm.batchOperationItems().length,
                            "can-close-tasks": _vm.canCloseSelectedTasks,
                            selectedPriorities: _vm.selectedPriorities,
                            selectedTags: _vm.selectedTags,
                            searchQuery: _vm.searchQuery,
                            dateRange: _vm.dateRange,
                            startDateRange: _vm.startDateRange,
                            endDateRange: _vm.endDateRange,
                            updateAtRange: _vm.updateAtRange,
                          },
                          on: {
                            "update:showOverdue": function ($event) {
                              _vm.showOverdue = Boolean($event)
                            },
                            "update:selectedPriorities": function ($event) {
                              _vm.selectedPriorities = $event
                            },
                            "update:selectedTags": function ($event) {
                              _vm.selectedTags = $event
                            },
                            "update:assignees": function ($event) {
                              _vm.assignees = $event
                            },
                            "update:owners": function ($event) {
                              _vm.owners = $event
                            },
                            "update:followers": function ($event) {
                              _vm.followers = $event
                            },
                            "update:createdBy": function ($event) {
                              _vm.createdBy = $event
                            },
                            "update:dateRange": function ($event) {
                              _vm.dateRange = $event
                            },
                            "update:startDateRange": function ($event) {
                              _vm.startDateRange = $event
                            },
                            "update:endDateRange": function ($event) {
                              _vm.endDateRange = $event
                            },
                            "update:updateAtRange": function ($event) {
                              _vm.updateAtRange = $event
                            },
                            "update:searchQuery": function ($event) {
                              _vm.searchQuery = $event
                            },
                            "apply-filters": _vm.handleApplyFilters,
                            "check-all-tasks": _vm.changeCheckedTasks,
                            "change-stage": _vm.checkDraggingTaskPermission,
                            "delete-tasks": _vm.checkDeleteTaskPermission,
                            "close-tasks": _vm.openCloseTasksModal,
                            search: _vm.handleSearchQuery,
                            "toggle-reset-filters": _vm.handleResetFilters,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "right-buttons",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "task-actions-container" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "task-action-button",
                                            on: {
                                              click: function ($event) {
                                                return _vm.beforeCreateTaskRow(
                                                  _vm.createTask
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "md-icon action-icon create-icon",
                                              },
                                              [_vm._v("add_task")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("task.createTask")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "action-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "task-action-button",
                                            on: { click: _vm.openArchive },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "md-icon action-icon archive-icon",
                                              },
                                              [_vm._v("archive")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.archive")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "action-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "task-action-button",
                                            on: { click: _vm.openCloseTask },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "md-icon action-icon done-icon",
                                              },
                                              [_vm._v("flaky")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [_vm._v("Kapatılmış Görevler")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2765173592
                          ),
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.localType === "list" ||
                    _vm.localType === "archive" ||
                    _vm.localType === "done"
                      ? _c("task-filter-bar", {
                          ref: "taskFilterBar",
                          attrs: {
                            assignees: _vm.assignees,
                            owners: _vm.owners,
                            followers: _vm.followers,
                            createdBy: _vm.createdBy,
                            "workflow-id": _vm.workflowId || null,
                            "show-overdue": Boolean(_vm.showOverdue),
                            selectedPriorities: _vm.selectedPriorities,
                            selectedTags: _vm.selectedTags,
                            searchQuery: _vm.searchQuery,
                            dateRange: _vm.dateRange,
                            startDateRange: _vm.startDateRange,
                            endDateRange: _vm.endDateRange,
                            updateAtRange: _vm.updateAtRange,
                          },
                          on: {
                            "update:showOverdue": function ($event) {
                              _vm.showOverdue = Boolean($event)
                            },
                            "update:assignees": function ($event) {
                              _vm.assignees = $event
                            },
                            "update:owners": function ($event) {
                              _vm.owners = $event
                            },
                            "update:followers": function ($event) {
                              _vm.followers = $event
                            },
                            "update:selectedPriorities": function ($event) {
                              _vm.selectedPriorities = $event
                            },
                            "update:selectedTags": function ($event) {
                              _vm.selectedTags = $event
                            },
                            "update:searchQuery": function ($event) {
                              _vm.searchQuery = $event
                            },
                            "update:dateRange": function ($event) {
                              _vm.dateRange = $event
                            },
                            "update:startDateRange": function ($event) {
                              _vm.startDateRange = $event
                            },
                            "update:endDateRange": function ($event) {
                              _vm.endDateRange = $event
                            },
                            "update:updateAtRange": function ($event) {
                              _vm.updateAtRange = $event
                            },
                            "update:createdBy": function ($event) {
                              _vm.createdBy = $event
                            },
                            "apply-filters": _vm.handleApplyFilters,
                            "toggle-reset-filters": _vm.handleResetFilters,
                            search: _vm.handleSearchQuery,
                            "filter-assignees": _vm.handleFilterAssignees,
                            "filter-other": _vm.handleFilterOther,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.localType === "done" ||
                    _vm.localType === "archive" ||
                    _vm.localType === "list"
                      ? _c(
                          "div",
                          { staticClass: "workflow-select-container" },
                          [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  value: _vm.workflowId || "",
                                  placeholder: "Default seçim yapınız",
                                  disabled: false,
                                  allowClear: "",
                                },
                                on: { change: _vm.handleWorkflowChange },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "" } },
                                  [_vm._v("Tümü")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.getWorkflows(), function (option) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: option.value,
                                      attrs: { value: option.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(option.label) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "board" },
              [
                _vm.localType === "workflowList"
                  ? _c("Workflow", {
                      on: { "selected-workflow": _vm.changeWorkflow },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "kanban" && _vm.workflowId
                  ? _c("TaskDraggable", {
                      ref: "taskDraggable",
                      attrs: {
                        "workflow-id": _vm.workflowId || null,
                        assignees: _vm.assignees,
                        owners: _vm.owners,
                        followers: _vm.followers,
                        createdBy: _vm.createdBy,
                        showOverdue: Boolean(_vm.showOverdue),
                        search: _vm.searchQuery,
                        selectedPriorities: _vm.selectedPriorities,
                        selectedPipelines: _vm.selectedPipelines,
                        startDateRange: _vm.startDateRange,
                        endDateRange: _vm.endDateRange,
                        dateRange: _vm.dateRange,
                        selectedTags: _vm.selectedTags,
                        updateAtRange: _vm.updateAtRange,
                        tasks: _vm.tasks,
                        basicTaskForm: _vm.basicTaskForm,
                        "checked-items": _vm.checkedItems,
                        isLoading: _vm.isLoading,
                        retryCount: _vm.retryCount,
                      },
                      on: {
                        "update:assignees": function ($event) {
                          _vm.assignees = $event
                        },
                        "update:owners": function ($event) {
                          _vm.owners = $event
                        },
                        "update:followers": function ($event) {
                          _vm.followers = $event
                        },
                        "update:showOverdue": function ($event) {
                          _vm.showOverdue = Boolean($event)
                        },
                        "update:selectedPriorities": function ($event) {
                          _vm.selectedPriorities = $event
                        },
                        "update:selectedTags": function ($event) {
                          _vm.selectedTags = $event
                        },
                        "update:selectedPipelines": function ($event) {
                          _vm.selectedPipelines = $event
                        },
                        "update:search": function ($event) {
                          _vm.searchQuery = $event
                        },
                        "update:dateRange": function ($event) {
                          _vm.dateRange = $event
                        },
                        "update:startDateRange": function ($event) {
                          _vm.startDateRange = $event
                        },
                        "update:endDateRange": function ($event) {
                          _vm.endDateRange = $event
                        },
                        "update:updateAtRange": function ($event) {
                          _vm.updateAtRange = $event
                        },
                        "update:createdBy": function ($event) {
                          _vm.createdBy = $event
                        },
                        updateCheckedItems: function ($event) {
                          _vm.checkedItems = $event
                        },
                        updateBasicTaskForm: _vm.basicTaskFormUpdated,
                        updateTaskList: _vm.taskListUpdated,
                        "apply-filters": _vm.handleApplyFilters,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "list"
                  ? _c("KanbanList", {
                      ref: "kanbanList",
                      attrs: {
                        assignees: _vm.assignees,
                        owners: _vm.owners,
                        followers: _vm.followers,
                        "workflow-id": _vm.workflowId || null,
                        showOverdue: Boolean(_vm.showOverdue),
                        search: _vm.searchQuery,
                        selectedPriorities: _vm.selectedPriorities,
                        selectedPipelines: _vm.selectedPipelines,
                        startDateRange: _vm.startDateRange,
                        endDateRange: _vm.endDateRange,
                        updateAtRange: _vm.updateAtRange,
                        dateRange: _vm.dateRange,
                        createdBy: _vm.createdBy,
                        selectedTags: _vm.selectedTags,
                      },
                      on: {
                        "update:assignees": function ($event) {
                          _vm.assignees = $event
                        },
                        "update:owners": function ($event) {
                          _vm.owners = $event
                        },
                        "update:followers": function ($event) {
                          _vm.followers = $event
                        },
                        "update:showOverdue": function ($event) {
                          _vm.showOverdue = Boolean($event)
                        },
                        "update:selectedPriorities": function ($event) {
                          _vm.selectedPriorities = $event
                        },
                        "update:selectedTags": function ($event) {
                          _vm.selectedTags = $event
                        },
                        "update:selectedPipelines": function ($event) {
                          _vm.selectedPipelines = $event
                        },
                        "update:search": function ($event) {
                          _vm.searchQuery = $event
                        },
                        "update:dateRange": function ($event) {
                          _vm.dateRange = $event
                        },
                        "update:startDateRange": function ($event) {
                          _vm.startDateRange = $event
                        },
                        "update:endDateRange": function ($event) {
                          _vm.endDateRange = $event
                        },
                        "update:updateAtRange": function ($event) {
                          _vm.updateAtRange = $event
                        },
                        "update:createdBy": function ($event) {
                          _vm.createdBy = $event
                        },
                        "apply-filters": _vm.handleApplyFilters,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "tags" ? _c("Tags") : _vm._e(),
                _vm._v(" "),
                _vm.localType === "archive"
                  ? _c("TaskArchiveList", {
                      ref: "taskArchiveList",
                      attrs: {
                        assignees: _vm.assignees,
                        owners: _vm.owners,
                        followers: _vm.followers,
                        "workflow-id": _vm.workflowId || null,
                        showOverdue: Boolean(_vm.showOverdue),
                        search: _vm.searchQuery,
                        selectedPriorities: _vm.selectedPriorities,
                        startDateRange: _vm.startDateRange,
                        endDateRange: _vm.endDateRange,
                        updateAtRange: _vm.updateAtRange,
                        dateRange: _vm.dateRange,
                        createdBy: _vm.createdBy,
                        selectedTags: _vm.selectedTags,
                      },
                      on: {
                        "update:assignees": function ($event) {
                          _vm.assignees = $event
                        },
                        "update:owners": function ($event) {
                          _vm.owners = $event
                        },
                        "update:followers": function ($event) {
                          _vm.followers = $event
                        },
                        "update:showOverdue": function ($event) {
                          _vm.showOverdue = Boolean($event)
                        },
                        "update:selectedPriorities": function ($event) {
                          _vm.selectedPriorities = $event
                        },
                        "update:selectedTags": function ($event) {
                          _vm.selectedTags = $event
                        },
                        "update:search": function ($event) {
                          _vm.searchQuery = $event
                        },
                        "update:dateRange": function ($event) {
                          _vm.dateRange = $event
                        },
                        "update:startDateRange": function ($event) {
                          _vm.startDateRange = $event
                        },
                        "update:endDateRange": function ($event) {
                          _vm.endDateRange = $event
                        },
                        "update:updateAtRange": function ($event) {
                          _vm.updateAtRange = $event
                        },
                        "update:createdBy": function ($event) {
                          _vm.createdBy = $event
                        },
                        "apply-filters": _vm.handleApplyFilters,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "done"
                  ? _c("DoneTask", {
                      ref: "doneTask",
                      attrs: {
                        assignees: _vm.assignees,
                        owners: _vm.owners,
                        followers: _vm.followers,
                        "workflow-id": _vm.workflowId || null,
                        showOverdue: Boolean(_vm.showOverdue),
                        search: _vm.searchQuery,
                        selectedPriorities: _vm.selectedPriorities,
                        startDateRange: _vm.startDateRange,
                        endDateRange: _vm.endDateRange,
                        updateAtRange: _vm.updateAtRange,
                        dateRange: _vm.dateRange,
                        createdBy: _vm.createdBy,
                        selectedTags: _vm.selectedTags,
                      },
                      on: {
                        "update:assignees": function ($event) {
                          _vm.assignees = $event
                        },
                        "update:owners": function ($event) {
                          _vm.owners = $event
                        },
                        "update:followers": function ($event) {
                          _vm.followers = $event
                        },
                        "update:showOverdue": function ($event) {
                          _vm.showOverdue = Boolean($event)
                        },
                        "update:selectedPriorities": function ($event) {
                          _vm.selectedPriorities = $event
                        },
                        "update:selectedTags": function ($event) {
                          _vm.selectedTags = $event
                        },
                        "update:search": function ($event) {
                          _vm.searchQuery = $event
                        },
                        "update:dateRange": function ($event) {
                          _vm.dateRange = $event
                        },
                        "update:startDateRange": function ($event) {
                          _vm.startDateRange = $event
                        },
                        "update:endDateRange": function ($event) {
                          _vm.endDateRange = $event
                        },
                        "update:updateAtRange": function ($event) {
                          _vm.updateAtRange = $event
                        },
                        "update:createdBy": function ($event) {
                          _vm.createdBy = $event
                        },
                        "apply-filters": _vm.handleApplyFilters,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "taskNotification"
                  ? _c("TaskNotification")
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "automation"
                  ? _c("AutomationList", {
                      attrs: { type: "event", module: "task" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.localType === "reports" ? _c("TaskReports") : _vm._e(),
                _vm._v(" "),
                _vm.localType === "sandbox" ? _c("WorkFlowSandbox") : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "modal-fade" } }, [
        _vm.deleteMultipleTasksModal
          ? _c(
              "div",
              {
                staticClass: "custom-modal-overlay",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.deleteMultipleTasksModal = false
                  },
                },
              },
              [
                _c("div", { staticClass: "delete-modal-container" }, [
                  _c("div", { staticClass: "delete-modal-header" }, [
                    _c("div", { staticClass: "warning-icon-wrapper" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "warning-icon",
                          attrs: {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "delete-modal-content" }, [
                      _c("h3", { staticClass: "delete-modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("task.deleteTask"))),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "delete-modal-message" }, [
                        _vm._v(_vm._s(_vm.$t("task.deleteTaskCont"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "delete-modal-info" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "info-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.batchOperationItems().length) +
                              " görev silinecek"
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "delete-modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-cancel",
                        on: {
                          click: function ($event) {
                            _vm.deleteMultipleTasksModal = false
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "btn-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6 18L18 6M6 6l12 12",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.dismiss")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-danger",
                        on: { click: _vm.deleteMultipleTasks },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "btn-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.delete")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "modal-fade" } }, [
        _vm.closeTasksModal
          ? _c(
              "div",
              {
                staticClass: "custom-modal-overlay",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.closeTasksModal = false
                  },
                },
              },
              [
                _c("div", { staticClass: "close-tasks-modal-container" }, [
                  _c("div", { staticClass: "close-tasks-modal-header" }, [
                    _c("div", { staticClass: "success-icon-wrapper" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "success-icon",
                          attrs: {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close-tasks-modal-content" }, [
                      _c("h3", { staticClass: "close-tasks-modal-title" }, [
                        _vm._v("Görevleri Kapat"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "close-tasks-modal-message" }, [
                        _vm._v(
                          "\n                            Seçili görevler kapatılacaktır. Bu işlemi onaylıyor musunuz?\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "close-tasks-modal-info" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "info-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.batchOperationItems().length) +
                              " görev kapatılacak"
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "close-tasks-modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-cancel",
                        on: {
                          click: function ($event) {
                            _vm.closeTasksModal = false
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "btn-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6 18L18 6M6 6l12 12",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        İptal\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-success",
                        on: { click: _vm.confirmCloseTasks },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "btn-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        Onayla\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "modal-fade" } }, [
        _vm.changeStageModal
          ? _c(
              "div",
              {
                staticClass: "custom-modal-overlay",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.changeStageModal = false
                  },
                },
              },
              [
                _c("div", { staticClass: "custom-modal-container" }, [
                  _c("div", { staticClass: "custom-modal-header" }, [
                    _c("div", { staticClass: "modal-header-content" }, [
                      _c("div", { staticClass: "modal-icon-wrapper" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "modal-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-title-section" }, [
                        _c("h3", { staticClass: "modal-title" }, [
                          _vm._v(_vm._s(_vm.$t("message.changeStage"))),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "modal-subtitle" }, [
                          _vm._v(_vm._s(_vm.$t("message.selectedCandidates"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "modal-close-btn",
                        on: {
                          click: function ($event) {
                            _vm.changeStageModal = false
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M18 6L6 18M6 6l12 12",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "pipeline-selection-grid" },
                      _vm._l(
                        _vm.workflows[_vm.workflowId].pipeline,
                        function (pipeline) {
                          return _c(
                            "div",
                            {
                              key: pipeline._id,
                              class: [
                                "pipeline-card",
                                {
                                  selected:
                                    _vm.selectedPipelineId === pipeline._id,
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  _vm.selectedPipelineId = pipeline._id
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "pipeline-card-inner" },
                                [
                                  _c("div", {
                                    staticClass: "pipeline-color-indicator",
                                    style: {
                                      backgroundColor:
                                        pipeline.color || "#47499d",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pipeline-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "pipeline-name" },
                                        [_vm._v(_vm._s(pipeline.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "pipeline-details" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "pipeline-order" },
                                            [
                                              _vm._v(
                                                "Sıra: " +
                                                  _vm._s(pipeline.order)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "pipeline-count" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  pipeline.taskCount || 0
                                                ) + " görev"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "pipeline-check" }, [
                                    _vm.selectedPipelineId === pipeline._id
                                      ? _c(
                                          "svg",
                                          {
                                            attrs: {
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M20 6L9 17l-5-5",
                                                stroke: "currentColor",
                                                "stroke-width": "2.5",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-cancel",
                        on: {
                          click: function ($event) {
                            _vm.changeStageModal = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        İptal\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "modal-btn modal-btn-primary",
                        attrs: { disabled: !_vm.selectedPipelineId },
                        on: { click: _vm.changeTaskPipeline },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "btn-icon",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5 13l4 4L19 7",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        Kaydet\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }